export const BOOKING_STATUS = ['confirmed', 'completed', 'expired'];

export const getBookingCount = (bookings) => {
  const filterBookingByStatus = bookings.filter((booking) => BOOKING_STATUS.includes(booking.status));
  return filterBookingByStatus.length;
};
